import { Component, Input, OnChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-metabase-public-embed',
  templateUrl: './metabase-public-embed.component.html',
  styleUrls: ['./metabase-public-embed.component.scss'],
})
export class MetabasePublicEmbedComponent implements OnChanges {
  @Input() url!: string;
  safeUrl!: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(): void {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }
}
